import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Check if the error is a ChunkLoadError
    if (
      error?.name === 'ChunkLoadError' || 
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module')
    ) {
      console.warn("ChunkLoadError detected, reloading page...");
      const isReloaded = sessionStorage.getItem('chunk_load_reloaded');
      if (!isReloaded) {
        sessionStorage.setItem('chunk_load_reloaded', 'true');
        window.location.reload();
      } else {
        sessionStorage.removeItem('chunk_load_reloaded');
      }
    } else {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  }

  componentDidMount() {
    this.handleGlobalError = (event) => {
      // ✅ Ignore ResizeObserver error (Chrome bug)
      if (
        event?.message &&
        event?.message.includes(
          "ResizeObserver loop completed with undelivered notifications"
        )
      ) {
        event.preventDefault();
        return;
      }
    };
    window.addEventListener("error", this.handleGlobalError);
  }

  componentWillUnmount() {
    window.removeEventListener("error", this.handleGlobalError);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", flexDirection: "column" }}>
          <h2>Oops! Something went wrong loading the page.</h2>
          <button 
            onClick={() => {
              sessionStorage.removeItem('chunk_load_reloaded');
              window.location.reload();
            }} 
            className="btn btn-primary mt-3"
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
